/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { PaceAnalysis } from './paceAnalysis';

/**
 * Pace analysis vs historical benchmark
 */
export type StudentProgressRecordPaceAnalysis = PaceAnalysis | null;
